import React from "react";
import { useSelector } from "react-redux";
import { Box, useTheme } from "@mui/material";

import { motion } from "framer-motion";
import useSWR from "swr";
import { useParams } from "react-router";
// import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";

import { ModalTab } from "./ModalTab/ModalTab";
import { TableModalHeight } from "../../../utils/ModalFunc";
import { getSettingState } from "../../../redux/features/settingSlice";
import ComponentBox from "./ComponentBox";
import CustomHelmet from "../CustomHelmet";
import { fetcherGetToken } from "../../../services/fetcher";

// const StyleBottomNav = styled(BottomNavigationAction)(({ theme }) => ({
//   "&.MuiBottomNavigationAction-root": {
//     borderRadius: "7px",
//     paddingTop: "3px",
//     fontWeight: 400,
//     fontSize: "16px",
//     lineHeight: "24px",
//     color: theme.palette.black.main,
//     maxWidth: "100%",
//   },
//   "&.MuiBottomNavigationAction-root.Mui-selected": {
//     backgroundColor: theme.palette.black.main,
//     color: theme.palette.white.main,
//     fontWeight: 700,
//   },
// }));

const TableModal = () => {
  const theme = useTheme();
  const params = useParams();
  const { tableModal, tableModalTab } = useSelector(getSettingState);
  var modalHeight = TableModalHeight();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  // const location = useLocation();
  // const { snackbarMode, snackbarTitle } = useSelector(getSettingState);

  // const handleShare = (e) => {
  //   e.stopPropagation();
  //   const viewURL = "https://azad.im";

  //   copy(viewURL + location.pathname);
  //   dispatch(setSnackbarMode(true));
  //   dispatch(setSnackbarTitle("Table link copied!"));
  // };

  const { data: about } = useSWR(
    [`${process.env.REACT_APP_API}/content/table/${params.tableId}/`, tokenStorage],
    fetcherGetToken
  );

  // const helmetTitle = () => {
  //   var title;

  //   title = about ? about.title + " | Azad" : "loading.. | Azad";

  //   return title;
  // };

  // const swipeHandleChangeTab = (index) => {
  //   dispatch(setTableModalTab(index));
  // };

  // const handleChangeTab = (event, newValue) => {
  //   dispatch(setTableModalTab(newValue));
  // };

  // useEffect(() => {
  //   TableModalSwipe(dispatch);
  // }, [dispatch]);

  const variants = {
    open: {
      top: "62px",
      transition: { type: "spring", stiffness: 700, damping: 30 },
    },
    closed: {
      top: modalHeight + "px",
      transition: { type: "spring", stiffness: 700, damping: 30 },
    },
  };

  return (
    <>
      <CustomHelmet
        title={about ? about.title + " | Azad" : "loading.. | Azad"}
        description={about?.title}
        imgUrl={about?.banner}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: "white.main",
        }}
      ></Box>
      <motion.div
        variants={variants}
        animate={tableModal ? "open" : "closed"}
        // drag='y'
        dragConstraints={{ top: 0, bottom: 0 }}
        dragElastic={0.12}
        // onDragEnd={(event, info) => {
        //   // if (info.offset.y > 200) {
        //   //   dispatch(setTableModal(false));
        //   // }
        //   // if (info.offset.y < -200) {
        //   //   dispatch(setTableModal(true));
        //   // }
        // }}
        style={{
          backgroundColor: theme.palette.white.main,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderTop: "2px solid",
          borderRight: "2px solid",
          borderLeft: "2px solid",
          borderColor: theme.palette.black.main,
          borderRadius: "16px 16px 0px 0px",
          position: "absolute",
          bottom: "64px",
          top: tableModal ? "62px" : modalHeight + "px",
          width: "100%",
          maxWidth: "450px",
          zIndex: 2,
        }}
      >
        {/* Nav Button  */}

        {/* <BottomNavigation
            sx={{
              height: "48px",
              boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
              borderRadius: "8px",
              overflow: "hidden",
              fontSize: "16px",
            }}
            value={tableModalTab}
            onChange={handleChangeTab}
          >
            <StyleBottomNav value={0} icon={"Thoughts"} />
            <StyleBottomNav value={1} icon={"About"} />
          </BottomNavigation> */}

        {/* <SwipeableViews
          style={{ width: "100%", padding: "0 16px " }}
          index={tableModalTab}
          onChangeIndex={swipeHandleChangeTab}
        > */}
        {/* <ModalTab value={tableModalTab} index={0}> */}
        {/* </ModalTab> */}
        <ModalTab value={tableModalTab} index={0}>
          <ComponentBox />
        </ModalTab>
        {/* </SwipeableViews> */}
      </motion.div>
    </>
  );
};
export default TableModal;
